import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles(() =>
  createStyles({
    main: {
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-end",
    },
    btn1: {
      color: "#475467",
      marginRight: "8px",
    },
    btn2: {
      backgroundColor: "#12B76A",
      color: "white",
    },
  })
);

export default useStyles;
